module.exports = __webpack_public_path__ + "media/images/iconTrendDown__errorRed--dark-4af96d60d47cd53d00db44b05ddbc109.png";